import React from "react";
import { RightOutlined } from "@ant-design/icons";
import styled from "styled-components";

const Container = styled.span`
  padding: 0 3px;
  cursor: pointer;
  margin-left: 2px;
  display: inline-block;
  &:hover {
    background: #eee;
  }
  &:active {
    background: #ddd;
  }
  .down {
    display: block;
    transform: rotate(90deg);
  }
`;

function Toggler({ extend, onClick }) {
  return (
    <Container onClick={onClick}>
      <span className={extend ? "down" : ""}>
        <RightOutlined />
      </span>
    </Container>
  );
}

export { Toggler };
